// extracted by mini-css-extract-plugin
export default {"headerMainContainer":"ShiftPatternContainer_headerMainContainer__f1Rr6","headerTopNoMarginBottom":"ShiftPatternContainer_headerTopNoMarginBottom__q+7J8"};